<nav class="navbar navbar-expand-lg navbar-light bg-white py-1">
  <!-- Hamburger icon for toggling the menu -->
  <button
    class="navbar-toggler"
    type="button"
    (click)="collapse.toggle()"
    data-toggle="collapse"
    aria-label="Toggle navigation"
    [attr.aria-expanded]="!isCollapsed"
    i18n-aria-label
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
    <div class="w-100 mx-auto py-2" id="search-div">
      <app-search [embedded]="true"></app-search>
    </div>
    @if (hasAnalytics()) {
      <button routerLink="/analytics" class="btn btn-transparent text-nowrap mx-2" i18n>
        <cds-icon shape="MathAndFinanceChartLine" />
        Quality Intelligence
      </button>
    }

    <app-help-block id="main-nav-help-block"></app-help-block>

    <!-- User icon and sub-menu items -->
    <div ngbDropdown display="dynamic">
      @let user = userState.user();

      <button
        ngbDropdownToggle
        type="button"
        class="btn btn-link me-2 no-caret px-2"
        id="userIconBtn"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        [ngbTooltip]="user?.email"
        placement="left"
      >
        <cds-avatar type="circle" [text]="userInitials()"></cds-avatar>
      </button>
      <div ngbDropdownMenu aria-labelledby="userIconBtn" class="shadow-lg above-sticky">
        <div class="d-flex dropdown-header text-black">
          <cds-avatar type="circle" [text]="userInitials()"></cds-avatar>
          <div class="d-flex flex-column ms-2">
            <div>{{ user?.name }}</div>
            <div class="text-secondary small">
              @if (user?.superAdmin) {
                <ng-container i18n>CRT SuperAdmin</ng-container>
              } @else {
                <ng-container i18n
                  >{{ userRole()?.name }} role in {{ userState.org()?.name }}</ng-container
                >
              }
            </div>
          </div>
        </div>
        <div class="dropdown-divider"></div>
        <a
          [routerLink]="['/settings', 'users', 'me']"
          class="dropdown-item no-caret"
          queryParamsHandling=""
        >
          <cds-icon shape="PeopleUser" class="me-1" />
          <ng-container i18n>Profile</ng-container>
        </a>
        <div class="dropdown-divider"></div>
        <div class="dropdown-header" i18n>ORGANIZATION</div>
        @if (userState.orgs().length > 1) {
          <app-org-switcher class="dropdown-item pointer"></app-org-switcher>
        }
        @if (userState.org(); as org) {
          <a
            [ngbTooltip]="org.name"
            [queryParams]="{ orgId: org.id, projectId: projectId() }"
            [routerLink]="['/orgs', 'settings']"
            class="dropdown-item"
            queryParamsHandling="replace"
          >
            <cds-icon shape="CommerceBuildings" class="me-1" />
            <ng-container i18n>Organization Settings</ng-container>
          </a>
          @if (isSuperOrProvisioningAdmin()) {
            <a
              [queryParams]="{ orgId: org.id, projectId: projectId() }"
              [routerLink]="['/ca']"
              class="dropdown-item"
              queryParamsHandling="replace"
            >
              <cds-icon shape="SecurityAndWarningsShieldCheck" class="me-1" />
              <ng-container i18n>Copado Admin</ng-container>
            </a>
          }
        }
        <div class="dropdown-divider"></div>
        <div class="dropdown-header" i18n>SUPPORT</div>
        <a
          class="dropdown-item"
          href="https://success.copado.com/s/"
          i18n-ngbTooltip
          ngbTooltip="Opens in a new tab"
          target="_blank"
        >
          <cds-icon shape="PeopleUsersFour" class="me-1" />
          <ng-container i18n>Copado Community</ng-container>
          <small class="ext-link small ms-1"><cds-icon shape="ArrowsArrowSquareOut" /></small>
        </a>
        <a
          class="dropdown-item"
          href="https://success.copado.com/s/learning-trac-detail-standard?ltui__urlRecordId=a9F5p0000010xRKEAY&ltui__urlRedirect=learning-trac-detail-standard"
          i18n-ngbTooltip
          ngbTooltip="Opens in a new tab"
          target="_blank"
        >
          <cds-icon shape="EducationStudent" class="me-1" />
          <ng-container i18n>Training</ng-container>
          <small class="ext-link ms-1"><cds-icon shape="ArrowsArrowSquareOut" /></small
        ></a>
        <div class="dropdown-divider"></div>
        <div i18n class="dropdown-header">LANGUAGE</div>
        <a
          [queryParams]="{ modal: Modal.ChangeLanguage }"
          [routerLink]="[]"
          class="dropdown-item"
          id="language-picker"
        >
          <cds-icon shape="CommunicationTranslate" class="me-1" />
          <ng-container i18n>Change Language</ng-container>
        </a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item text-danger logout" routerLink="/u/logout">
          <cds-icon shape="SystemAndDevicesSignOut" class="me-1" />
          <ng-container i18n>Log out</ng-container>
        </a>
      </div>
    </div>
  </div>
</nav>
